module.exports = __webpack_public_path__ + "img/ethics.ca071ef3.png";